export default __webpack_public_path__ + "static/media/cezar.b87b8e54.png";